import { ListBox as AriaListBox, ListBoxProps as AriaListBoxProps } from 'react-aria-components';

import { css } from '@allenai/varnish-panda-runtime/css';

import { cx } from '@/utils/cx';

import selectRecipe, { SelectRecipeProps } from '@/components/select/select.styles';
import focusRing from '@/components/shared/focusRing.styles';

type SelectItem = { id: string | number; name: string };

type SelectListBoxProps = {
    label?: string;
    className?: string;
} & AriaListBoxProps<object> &
    SelectRecipeProps;

const SelectListBox = ({ className, ...rest }: SelectListBoxProps) => {
    const [variantProps, localProps] = selectRecipe.splitVariantProps(rest);
    // `raw` receipe is required to be able to merge css objects (used in focus ring)
    const recipeClassNames = selectRecipe.raw(variantProps);
    return (
        <AriaListBox
            {...localProps}
            // we need to wrap the `raw` focusRing and `raw` recipeClassNames.thumb in `css()` to merge them
            // there is no garauntee which class will take precidence
            className={cx(css(recipeClassNames.listBox, focusRing), className)}
        />
    );
};

export { SelectListBox, SelectListBox as default };
export type { SelectListBoxProps, SelectItem };
